/**
 * Navigation IA - sidebar primary pages. Create/edit/detail routes are
 * reached contextually (CTAs, row actions), not from the sidebar.
 */

export interface NavItem {
  label: string;
  path: string;
  /** Optional operator hint shown as native title tooltip. */
  description?: string;
  /** When true, the browser leaves the admin SPA (full page load). */
  external?: boolean;
}

export interface NavSection {
  label: string;
  items: NavItem[];
}

export const NAV_SECTIONS: NavSection[] = [
  { label: "Overview", items: [{ label: "Dashboard", path: "/dashboard" }] },
  {
    label: "Data Access",
    items: [
      {
        label: "Service Accounts",
        path: "/services",
        description: "Register services, issue API keys, and assign access groups",
      },
      {
        label: "Access Groups",
        path: "/groups",
        description: "Reusable column-level permissions per entity",
      },
      {
        label: "Admin Access Requests",
        path: "/access-requests",
        description: "Approve or reject Microsoft users for this console",
      },
    ],
  },
  {
    label: "Data Sync",
    items: [
      {
        label: "Sync Monitor",
        path: "/sync",
        description: "Live sync activity and manual runs",
      },
      {
        label: "Sync History",
        path: "/sync/history",
        description: "Past sync runs and outcomes",
      },
    ],
  },
  {
    label: "Monitoring",
    items: [
      { label: "System Health", path: "/health" },
      {
        label: "API Access Logs",
        path: "/access-logs",
        description: "API calls made by service accounts",
      },
      {
        label: "Audit Trail",
        path: "/audit",
        description: "Admin changes: who, what, when",
      },
    ],
  },
  {
    label: "Settings",
    items: [{ label: "Configuration", path: "/configuration" }],
  },
];

/** Every route in the Navigation IA table, including contextual (non-sidebar) routes. */
export const ALL_ROUTES = [
  "/",
  "/dashboard",
  "/services",
  "/services/new",
  "/services/:id",
  "/groups",
  "/groups/new",
  "/groups/:id",
  "/access-requests",
  "/sync",
  "/sync/history",
  "/sync/history/:id",
  "/audit",
  "/access-logs",
  "/health",
  "/configuration",
] as const;
